module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/keepCoolNoPPAPresents-81aa5e2a52cdb5d614f38589ec185d01.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/keepCoolNoPPAPresents.png
// module id = 2453
// module chunks = 2